function fadeInAnim() {
    var blackMask = document.querySelector('.quiz-outer-ctr__black-mask');
    if (!blackMask) return;
    blackMask.style.visibility = 'visible';
    document.querySelector('.quiz-outer-container').classList.add('fade-in-anim');
    document.querySelector('.title-ctr.intro-page').classList.add('js-animation-done');
}

function quizCompleteOrNot(){
    if (localStorage.recommendedProduct){
        fadeInResults();
        document.querySelector('.recommended-product').classList.add('js-animation-done');
        document.querySelector('.' + localStorage.recommendedProduct).classList.remove('hide');
        if (localStorage.recommendedProduct2){
            document.querySelector('.' + localStorage.recommendedProduct2).classList.remove('hide');
        }
        if (localStorage.recommendedProduct3){
            document.querySelector('.' + localStorage.recommendedProduct3).classList.remove('hide');
        }
        if (localStorage.recommendedProduct4){
            document.querySelector('.' + localStorage.recommendedProduct4).classList.remove('hide');
        }
    }else{
        introPageRefresh();
    }
}

function autoAddDiscount() {
    // Save the discount code as a session cookie
    document.cookie = `discount_code=${quizDiscountCode}; path=/`;

    // Send GET request to "/discount/[discountcode]"
    fetch(`/discount/${quizDiscountCode}`)
        .then(function() {
            // After the discount code has been applied, force the cart to update so the discount is visible instantly
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    updates: {},
                })
            }).catch(function(error) {
                console.error('Error:', error);
            });
        })
        .catch(function(error) {
            console.error('Error:', error);
        });
}

function introPageRefresh(){
    document.querySelector('.intro-page').classList.remove('hide');
    document.querySelector('.intro-page').style.display = 'block';
    document.querySelector('.intro-page').style.opacity = '1';
    document.querySelector('.intro-page').classList.remove('hide');
    document.querySelector('.quiz-container__inner-ctr').style.display = 'block';
}

function startQuiz(){
    transitionToNext('.intro-page', '.question-one');
}

function introPageBackBtn(){
    transitionToNext('.question-one', '.intro-page');
}

function hydrocarbonSelection(){
    transitionToNext('.question-one', '.question-three-halves');
}

function CO2Selection(){
    transitionToNext('.question-one', '.question-two-alt');
}

function yesPesticideSelection(){
    transitionToNext('.question-three-halves', '.question-two-alt2');
}

function pesticideBackBtn(){
    transitionToNext('.question-two', '.question-three-halves');
}

function pesticideBackBtn2(){
    transitionToNext('.question-two-alt2', '.question-three-halves');
}

function pesticideBackBtn3(){
    transitionToNext('.question-five-thirds', '.question-three-halves');
}

function yesMetalsSelection(){
    transitionToNext('.question-five-thirds', '.question-three-new9');
}

function noMetalsSelection(){
    transitionToNext('.question-five-thirds', '.question-two');
}

function metalsBackBtn(){
    transitionToNext('.question-two', '.question-five-thirds');
}

function metalsBackBtn2(){
    transitionToNext('.question-three-new9', '.question-five-thirds');
}

function heavyPesticideSelection(){
    transitionToNext('.question-two-alt2', '.question-three-new7');
}

function lowPesticideSelection(){
    transitionToNext('.question-two-alt2', '.question-three-new8');
}

function noPesticideSelection(){
    transitionToNext('.question-three-halves', '.question-five-thirds');
}

function inlineSelection(){
    showRecommendedProduct('.question-two-alt');
    document.querySelector('.CR2').classList.remove('hide');
    localStorage.recommendedProduct = 'CR2';
    autoAddDiscount();
}

function postProcessSelection(){
    transitionToNext('.question-two-alt', '.question-three-new3');
}

function ethanolSelection(){
    transitionToNext('.question-one', '.question-two2');
}

function solventBackBtn(){
    transitionToNext('.question-three-halves', '.question-one');
}

function solventBackBtn2(){
    transitionToNext('.question-two2', '.question-one');
}

function solventBackBtn3(){
    transitionToNext('.question-two-alt', '.question-one');
}

function heavyColorSelection(){
    transitionToNext('.question-two', '.question-three-new6');
}

function moderateColorSelection(){
    transitionToNext('.question-two', '.question-three-new5');
}

function lightColorSelection(){
    transitionToNext('.question-two', '.question-three-new4');
}

function heavyColorSelection2(){
    transitionToNext('.question-two2', '.question-three-new2');
}

function lightColorSelection2(){
    transitionToNext('.question-two2', '.question-three-new');
}

function colorBackBtn(){
    transitionToNext('.question-three-new', '.question-two2');
}

function colorBackBtn1a(){
    transitionToNext('.question-three-new2', '.question-two2');
}

function colorBackBtn2(){
    transitionToNext('.question-three-new4', '.question-two');
}

function colorBackBtn2a(){
    transitionToNext('.question-three-new5', '.question-two');
}

function colorBackBtn2b(){
    transitionToNext('.question-three-new6', '.question-two');
}

function colorBackBtn3(){
    transitionToNext('.question-three-new3', '.question-two-alt');
}

function pestLevelBackBtn(){
    transitionToNext('.question-three-new7', '.question-two-alt2');
}

function pestLevelBackBtn2(){
    transitionToNext('.question-three-new8', '.question-two-alt2');
}

function granularSelection(){
    document.querySelector('.question-three-new').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.Activated-Alumina').classList.remove('hide');
    localStorage.recommendedProduct = 'Activated-Alumina';
    autoAddDiscount();
}

function powderedSelection(){
    document.querySelector('.question-three-new').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.PR-W').classList.remove('hide');
    localStorage.recommendedProduct = 'PR-W';
    autoAddDiscount();
}

function granularSelection2(){
    document.querySelector('.question-three-new2').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.G-CRAC').classList.remove('hide');
    localStorage.recommendedProduct = 'G-CRAC';
    autoAddDiscount();
}

function powderedSelection2(){
    document.querySelector('.question-three-new2').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.PR-W').classList.remove('hide');
    localStorage.recommendedProduct = 'PR-W';
    autoAddDiscount();
}

function granularSelection3(){
    document.querySelector('.question-three-new3').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.G-CRAC').classList.remove('hide');
    localStorage.recommendedProduct = 'G-CRAC';
    autoAddDiscount();
}

function powderedSelection3(){
    document.querySelector('.question-three-new3').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.PR-W').classList.remove('hide');
    localStorage.recommendedProduct = 'PR-W';
    autoAddDiscount();
}

function granularSelection4(){
    document.querySelector('.question-three-new4').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.CRX').classList.remove('hide');
    localStorage.recommendedProduct = 'CRX';
    autoAddDiscount();
}

function powderedSelection4(){
    document.querySelector('.question-three-new4').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.B80').classList.remove('hide');
    localStorage.recommendedProduct = 'B80';
    autoAddDiscount();
}

function granularSelection5(){
    document.querySelector('.question-three-new5').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.CRY').classList.remove('hide');
    localStorage.recommendedProduct = 'CRY';
    autoAddDiscount();
}

function powderedSelection5(){
    document.querySelector('.question-three-new5').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.Perform-5000').classList.remove('hide');
    localStorage.recommendedProduct = 'Perform-5000';
    autoAddDiscount();
}

function granularSelection6(){
    document.querySelector('.question-three-new6').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.CR41').classList.remove('hide');
    localStorage.recommendedProduct = 'CR41';
    autoAddDiscount();
}

function powderedSelection6(){
    document.querySelector('.question-three-new6').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.SILICA-GEL').classList.remove('hide');
    localStorage.recommendedProduct = 'SILICA-GEL';
    autoAddDiscount();
}

function granularSelection7(){
    document.querySelector('.question-three-new7').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.G-CRAC').classList.remove('hide');
    localStorage.recommendedProduct = 'G-CRAC';
    autoAddDiscount();
}

function powderedSelection7(){
    document.querySelector('.question-three-new7').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.CRAC').classList.remove('hide');
    localStorage.recommendedProduct = 'CRAC';
    autoAddDiscount();
}

function granularSelection8(){
    document.querySelector('.question-three-new8').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.PR-O').classList.remove('hide');
    localStorage.recommendedProduct = 'PR-O';
    autoAddDiscount();
}

function powderedSelection8(){
    document.querySelector('.question-three-new8').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.PR-W').classList.remove('hide');
    localStorage.recommendedProduct = 'PR-W';
    autoAddDiscount();
}

function granularSelection9(){
    document.querySelector('.question-three-new9').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.G-CRAC').classList.remove('hide');
    localStorage.recommendedProduct = 'G-CRAC';
    autoAddDiscount();
}

function powderedSelection9(){
    document.querySelector('.question-three-new9').classList.add('hide');
    showRecommendedProduct();
    document.querySelector('.MB-5').classList.remove('hide');
    localStorage.recommendedProduct = 'MB-5';
    autoAddDiscount();
}

function showRecommendedProduct(fadeOutQuestion) {
    const fadeQuestion = document.querySelector(fadeOutQuestion);
    const elements = document.querySelectorAll('.quiz-container__inner-ctr, .quiz-outer-container, .quiz-outer-ctr__black-mask, .quiz__logo');
    elements.forEach(element => element.style.display = 'none');
    if (fadeQuestion) {
        fadeQuestion.classList.add('hide');
    }
    setTimeout(fadeInResults, 50);
    setTimeout(function(){
        document.querySelector('.recommended-product').classList.add('js-animation-done');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 50);
}

function fadeInResults() {
    document.querySelector('.quiz-container__inner-ctr').style.display = 'none';
    const blackMask = document.querySelector('.quiz-outer-ctr__black-mask');
    blackMask.style.display = 'block';
    blackMask.style.backgroundColor = 'white';
    const recommendedProduct = document.querySelector('.recommended-product');
    recommendedProduct.classList.remove('hide');
    recommendedProduct.style.display = 'block';
    const quizContainers = document.querySelectorAll('.quiz-container, .quiz-outer-container');
    quizContainers.forEach(container => {
        container.classList.remove('bg-image', 'bg-image2');
        container.style.display = 'flex';
    });

    if (document.body &&
        (document.body.classList.contains('page-free-sample-top-nav') ||
        document.body.classList.contains('page-free-sample-LP-quiz'))
    ) {
        pluralToSingular(); // for Free Sample quizzes only
    }

}

function fadeOut(element, duration = 200) {
    if (!element) return;
    element.style.transition = `opacity ${duration}ms ease-out`;
    element.style.opacity = '0';

    setTimeout(() => {
        element.classList.add('hide');
        element.style.display = 'none';
    }, duration);
}

function fadeIn(element, duration = 200) {
    if (!element) return;
    element.classList.remove('hide');
    element.style.display = 'block';
    element.style.opacity = '0';
    element.style.transition = `opacity ${duration}ms ease-in`;

    requestAnimationFrame(() => {
        element.style.opacity = '1';
    });
}

function transitionToNext(currentSelector, ...nextSelectors) {
    const currentElement = document.querySelector(currentSelector);
    
    if (currentElement) {
        fadeOut(currentElement, 200);
    }

    setTimeout(() => {
        nextSelectors.forEach(selector => {
            const nextElement = document.querySelector(selector);
            fadeIn(nextElement, 200);
        });
    }, 200);
}

function retakeQuiz(){
    localStorage.recommendedProduct = '';
    localStorage.recommendedProduct2 = '';
    localStorage.recommendedProduct3 = '';
    localStorage.recommendedProduct4 = '';
    document.querySelector('.recommended-product').classList.add('hide');
    introPageRefresh();
    document.querySelector('.quiz-container').classList.add('bg-image');
    document.querySelector('.quiz-outer-container').classList.add('bg-image2');
    document.querySelectorAll('.quiz-product-card').forEach(function(card) {
        card.classList.add('hide');
    });
    document.querySelector('.quiz__logo').style.display = 'block';
    document.querySelector('.recommended-product').classList.remove('js-animation-done');
  
 //  	document.cookie = `discount_code=CLEARQUIZDISCOUNT; path=/`;
	// $.get(`/discount/CLEARQUIZDISCOUNT`)
	// 	.done(function() {
	// 		$.ajax({
	// 			url: '/cart/update.js',
	// 			method: 'POST',
	// 			contentType: 'application/json',
	// 			data: JSON.stringify({
	// 				updates: {},
	// 			}),
	// 			success: function(response) {
	// 				console.log('Cart updated:', response);
	// 			},
	// 			error: function(jqXHR, textStatus, errorThrown) {
	// 				console.error('Error:', textStatus, errorThrown);
	// 			}
	// 		});
	// 	})
	// 	.fail(function(jqXHR, textStatus, errorThrown) {
	// 		console.error('Error:', textStatus, errorThrown);
	// 	});
}